import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { getRoleLabel, getBlockModeLabel, getJourneyModeLabel, getWorkStatusLabel } from '../../helpers/user';
import {  
  Card,
  Button,
  Header,
  Label,
  Loader,
  Grid,
  Input,
  Icon,
  Popup,
  Form,
  Dropdown,
  Confirm,
  GridColumn,  
} from 'semantic-ui-react';
import { userActions } from '../../actions/user.actions';
import PropTypes from 'prop-types';
import { history } from '../../helpers';
import _ from 'lodash';
import { PaginationContainer } from '../../components/PaginationContainer';
import moment from 'moment';
import momentDurationFormatSetup from "moment-duration-format";
import { userConstants } from '../../constants/user.constants';

class UserIndexScreen extends Component {
  constructor(props) {
    super(props);

		this.state = {
			filterOpen: false,
			filters: {},
			filterSearch: null,
			search: null,
			users: null,
			confirmOpen: false,
			confirmAction: null,
			confirmUser: null,
			confirmMessage: null,
		};
	}

	static get propTypes() {
		return {
			users: PropTypes.any,
			managers: PropTypes.any,
			confirmOpen: PropTypes.bool,
			confirmAction: PropTypes.string,
			confirmMessage: PropTypes.string,
			confirmUser: PropTypes.any,
			me: PropTypes.any,
			loading: PropTypes.bool,
			t: PropTypes.any,
			history: PropTypes.any,
		};
	}

	componentDidMount() {
		this.handleSearchDebounced = _.debounce(function () {
			this.fetchUsers();
		}, 500);

		this.handleFilterSearchDebounced = _.debounce(function () {
			this.fetchManagers();
		}, 500);

		this.fetchManagers();
		this.fetchUsers();
	}

	fetchUsers(isExport) {
		const { dispatch } = this.props;
		const { page, search, filters } = this.state;
		const newFilters = { ...filters };
		Object.keys(newFilters).forEach((filter) => {
			if (newFilters[filter] === '') {
				delete newFilters[filter];
			}
		});
		dispatch(userActions.fetch({ page, search, export: isExport ? true : null, ...newFilters }));
	}

	exportXlsx() {
		this.fetchUsers(true);
	}

	handleSearch(search) {
		this.setState({ search, page: 1 });
		this.handleSearchDebounced();
	}

	handlePageChange(activePage) {
		this.setState({ page: activePage }, () => this.fetchUsers());
	}

  showConfirm(user, action) {
    let msg = `Tem certeza que deseja remover o usuário ${user.Name}?`;
    if (action == 'unblock') {
      msg = `Tem certeza que deseja desbloquear o acesso do usuário ${user.Name}?`;
    }
    this.setState({
      confirmOpen: true,
      confirmAction: action,
      confirmUser: user,
      confirmMessage: msg
    });
  }    

  closeConfirm() {
    this.setState({ confirmOpen: false});
  }

  executeConfirm() {
    const { dispatch } = this.props;
    const { confirmUser, confirmAction } = this.state;
    if (confirmAction == 'remove') {
      dispatch(userActions.remove(confirmUser.Id)).then(() => this.fetchUsers());
    } else if (confirmAction == 'unblock') {
      dispatch(userActions.unblock(confirmUser.Id)).then(() => this.fetchUsers());
    }

    setTimeout(() => this.fetchUsers(), 1000);
    this.setState({
      confirmOpen: false,
      confirmAction: null,
      confirmUser: null,
      confirmMessage: null
    });
  }

  goToCreate() {
    history.push('/user/create');
  }	handleFilterOpen = () => {
		const { filterOpen } = this.state;
		this.setState({ filterOpen: !filterOpen });
	};

	blockModeOptions() {
		return [
			{
				key: userConstants.BLOCK_MODE_AUTO,
				value: userConstants.BLOCK_MODE_AUTO,
				text: getBlockModeLabel(userConstants.BLOCK_MODE_AUTO),
			},
			{
				key: userConstants.BLOCK_MODE_ENABLED,
				value: userConstants.BLOCK_MODE_ENABLED,
				text: getBlockModeLabel(userConstants.BLOCK_MODE_ENABLED),
			},
			{
				key: userConstants.BLOCK_MODE_DISABLED,
				value: userConstants.BLOCK_MODE_DISABLED,
				text: getBlockModeLabel(userConstants.BLOCK_MODE_DISABLED),
			},
		];
	}

	roleOptions() {
		return [
			{
				key: userConstants.ROLE_USER,
				value: userConstants.ROLE_USER,
				text: getRoleLabel(userConstants.ROLE_USER),
			},
			{
				key: userConstants.ROLE_MANAGER,
				value: userConstants.ROLE_MANAGER,
				text: getRoleLabel(userConstants.ROLE_MANAGER),
			},
			{
				key: userConstants.ROLE_APPROVER,
				value: userConstants.ROLE_APPROVER,
				text: getRoleLabel(userConstants.ROLE_APPROVER),
			},
			{
				key: userConstants.ROLE_SERVICE_DESK,
				value: userConstants.ROLE_SERVICE_DESK,
				text: getRoleLabel(userConstants.ROLE_SERVICE_DESK),
			},
			{
				key: userConstants.ROLE_ADMIN,
				value: userConstants.ROLE_ADMIN,
				text: getRoleLabel(userConstants.ROLE_ADMIN),
			},
		];
	}

	handleFilterSearchChange(search) {
		this.setState({ filterSearch: search });
		this.handleFilterSearchDebounced();
	}

	fetchManagers() {
		const { dispatch } = this.props;
		const { filterSearch } = this.state;
		dispatch(userActions.managers({ search: filterSearch, orderBy: 'Name' }));
	}

	simpleSearch(options, query) {
		query = query.toLowerCase();
		return options.filter((opt) => {
			return opt.text.toLowerCase().indexOf(query) >= 0 || opt.description.toLowerCase().indexOf(query) >= 0;
		});
	}

  render() {    
    const { filterOpen } = this.state;
	const { users, user, managers, loading, me, t } = this.props;

	// Check Permission
	if (me && me.permissions && !me.permissions.includes("user.fetch")) {
		window.location.href = "/";
		return;
	}

    var days = ['domingo' , 'segunda-feira', 'terça-feira', 'quarta-feira', 'quinta-feira', 'sexta-feira', 'sábado'];
    let managerOptions = [];
		if (managers && managers.Results) {
			managerOptions = managers.Results.map((item) => {
				return {
					key: item.Id,
					value: item.Id,
					text: item.Name,
					description: item.Email,
					username: item.Username,
				};
			});

			if (user?.immediateSuperior) {
				managerOptions.push({
					key: user.immediateSuperior.Id,
					value: user.immediateSuperior.Id,
					text: user.immediateSuperior.Name,
					description: user.immediateSuperior.Email,
					username: user.immediateSuperior.Username,
				});
			}

			if (user?.mediateSuperior) {
				managerOptions.push({
					key: user.mediateSuperior.Id,
					value: user.mediateSuperior.Id,
					text: user.mediateSuperior.Name,
					description: user.mediateSuperior.Email,
					username: user.mediateSuperior.Username,
				});
			}
		}

    return (
      <Fragment>
        <Loader active={loading}>Carregando...</Loader>
        <Confirm open={this.state.confirmOpen} content={this.state.confirmMessage} onCancel={() => this.closeConfirm()} onConfirm={() => this.executeConfirm()} />
        <Header>
          <h1>Usuários</h1>   
        </Header>

        <Grid stackable>
          <Grid.Row>            
          		<Grid.Column textAlign="left" width={10} style={{ display: 'flex' }}>
							<Input
								style={{ width: '100%' }}
								icon="search"
								fluid
								onChange={(e, data) => this.handleSearch(data.value)}
								placeholder="Buscar"
								loading={loading}
								className="search-input"
							/>
							<Popup
								open={filterOpen}
								position={'bottom center'}
								flowing
								trigger={
									<Button
										basic
										style={{ width: '150px', borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
										onClick={this.handleFilterOpen}
									>
										<Icon name="filter" />
										Filtros
									</Button>
								}
							>
								<h1 style={{ width: 300, textAlign: 'center', fontSize: 16 }}>Filtros:</h1>
								<Form.Field required>
									<label>Status</label>
									<Dropdown
										fluid
										selection
										clearable
										placeholder={'Selecione'}
										label="Status"
										name="active"
										options={[
											{ text: 'Ativo', value: true },
											{ text: 'Inativo', value: false },
										]}
										onChange={(event, data) => {
											const { filters } = this.state;
											this.setState({ filters: { ...filters, active: data.value } }, () => this.fetchUsers());
										}}
										value={this.state.filters?.active}
									/>
								</Form.Field>
								<Form.Field style={{ marginTop: 10 }}>
									<label>Superior</label>
									<Dropdown
										fluid
										selection
										clearable
										placeholder="Selecione"
										label="Superior"
										name="immediateSuperiorId"
										options={managerOptions}
										onChange={(event, data) => {
											const { filters } = this.state;
											this.setState({ filters: { ...filters, immediateSuperiorId: data.value } }, () =>
												this.fetchUsers(),
											);
										}}
										loading={loading}
										onSearchChange={(e, data) => this.handleFilterSearchChange(data.searchQuery)}
										search={(opt, qry) => this.simpleSearch(opt, qry)}
										value={this.state.filters?.immediateSuperiorId}
									/>
								</Form.Field>
								<Form.Field style={{ marginTop: 10 }}>
									<label>Modo de Bloqueio</label>
									<Dropdown
										fluid
										selection
										clearable
										placeholder="Selecione"
										label="Modo Bloqueio"
										name="blockMode"
										options={this.blockModeOptions()}
										onChange={(event, data) => {
											const { filters } = this.state;
											this.setState({ filters: { ...filters, blockMode: data.value } }, () => this.fetchUsers());
										}}
										value={this.state.filters?.blockMode}
									/>
								</Form.Field>
								<Form.Field style={{ marginTop: 10 }}>
									<label>Perfil</label>
									<Dropdown
										fluid
										selection
										clearable
										placeholder="Selecione"
										label="Perfil"
										name="role"
										options={this.roleOptions()}
										onChange={(event, data) => {
											const { filters } = this.state;
											this.setState({ filters: { ...filters, role: data.value } }, () => this.fetchUsers());
										}}
										value={this.state.filters?.role}
									/>
								</Form.Field>
							</Popup>							
						</Grid.Column>

			<Grid.Column textAlign='right' width={3}>
				<Button onClick={() => this.exportXlsx()} fluid>
					<Icon name='file excel' /> Exportar
				</Button>
			</Grid.Column>
            { me && me.permissions.includes("user.create") &&
            <Grid.Column textAlign='right' width={3}>				
              <Button color='primary' fluid onClick={this.goToCreate}>Novo Usuário</Button>
            </Grid.Column>}
          </Grid.Row>          
        </Grid>     
        
        <Card.Group>
          { (!users || (users.Results && users.TotalNumberOfRecords == 0)) &&
            <Card header='Nenhum usuário' fluid />
          }

          { users && users.Results && users.Results.map((user) => {           
            return <Card key={user.Id} fluid>
              <Card.Content>
                <Card.Header>
                  {user.Name}
                  <Label style={{float: "right", marginRight: '4px'}} color='grey'>
                    {user.Username}
                  </Label>               
                  {user.Unblocked &&
                    <Label style={{float: "right", marginRight: '4px'}} color='teal'>
                      Desbloqueado
                    </Label>}                    
                  {user.ExternalId &&
                    <Label style={{float: "right", marginRight: '4px'}} color='blue'>
                      {user.ExternalId}
                    </Label>}                    
                  <Label style={{float: "right", marginRight: '4px'}} color={user.Active ? 'green' : 'red'}>
                    {user.Active ? 'Ativo' : 'Inativo'}
                  </Label>
                </Card.Header>
                <Card.Meta>
                  {user.Email} 
                </Card.Meta>
                <Card.Description>
				  <div>
				  {user.AllowSelfApproval && <Label size='small' color='olive'>
                      Auto Aprovação
                    </Label>}
					{user.BlockGroupChanges && <Label size='small' color='brown'>
                      Bloqueado Alterações
                    </Label>}
				  </div>
				  <p><strong>Situação:</strong> {getWorkStatusLabel(user.Status)} {user.StatusText ? `(${user.StatusText})` : ''}</p>				  
                  <p><strong>Perfil:</strong> {getRoleLabel(user.Role)} </p>                  
                  <p><strong>Modo Bloqueio:</strong> {getBlockModeLabel(user.BlockMode)}</p>                  
                  <p><strong>Modo Jornada:</strong> {getJourneyModeLabel(user.JourneyMode)}</p>                  
                  <p><strong>Superior Imediato:</strong> {user.ImmediateSuperior ? user.ImmediateSuperior.Name : '-'}</p>                  
                  <p><strong>Superior Mediato:</strong> {user.MediateSuperior ? user.MediateSuperior.Name : '-'}</p>				  				  
                  {user.DocumentNumber && <p><strong>PIS/Identidade:</strong> {user.DocumentNumber}</p>}
                  <p><strong>Jornada:</strong> {user.WorkSchedule && user.WorkSchedule.length > 0 ? user.WorkSchedule.length + ' dias' : 'Não definida'}</p>
                  { user.WorkSchedule && user.WorkSchedule.length > 0 && user.WorkSchedule.map((schedule) => {
                    return <div key={schedule.Id}>
                      <p className='work-schedule'>
                        <strong>{days[schedule.WeekDay]}</strong>&nbsp;
                        Entrada: {moment.duration(schedule.StartTime.Hours + ':' + schedule.StartTime.Minutes).format("HH:mm", { trim: false})}&nbsp;
                        Jornada: {moment.duration(schedule.WorkMinutes, "minutes").format("HH:mm", { trim: false })}&nbsp;
                        Almoço: {moment.duration(schedule.LunchMinutes, "minutes").format("HH:mm", { trim: false })}&nbsp;
                        Tolerância Entrada/Saída: {moment.duration(schedule.StartToleranceMinutes, "minutes").format("HH:mm", { trim: false })}/{moment.duration(schedule.EndToleranceMinutes, "minutes").format("HH:mm", { trim: false })}&nbsp;
                        </p>
                      </div>                      
                  })}                    
                </Card.Description>  
              </Card.Content>              
              <Card.Content extra>                
                  { me && me.permissions.includes("user.update") && (me.Role === userConstants.ROLE_ADMIN || user.Role !== userConstants.ROLE_ADMIN) && <Button size='mini' secondary icon onClick={() => history.push(`/user/update/${user.Id}`) }>
                    <Icon name='edit' />
                    Alterar
                  </Button>}

                  { me && me.permissions.includes("user.remove") && <Button size='mini' color='red' icon onClick={() => this.showConfirm(user, 'remove') }>
                    <Icon name='cancel' />
                    Excluir
                  </Button>}              

                  { me && me.permissions.includes("user.unlock") && <Button size='mini' color='orange' icon onClick={() => this.showConfirm(user, 'unblock') }>
                    <Icon name='unlock' />
                    Desbloquear
                  </Button>}
              </Card.Content>          
            </Card>                      
          }) }
        </Card.Group>

        <PaginationContainer registers={users} onPageChange={(e, { activePage }) => this.handlePageChange(activePage) } />        
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { users } = state;      

  return { 
    users,
    managers: users.managers || null,
    loading: users.loading,
    me: users.me || null,
   };
}

const connectedUserIndexScreen = connect(mapStateToProps)(UserIndexScreen);
export { connectedUserIndexScreen as UserIndexScreen };
